import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import useCart from '../../data/hooks/cart_hook';
import { RootState } from '../../data/reducers';
import { AppDispatch } from '../../data/storeConfig';
import { CartProductTile } from '../../shared/components/product_components/cart_product_tile';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import { formatAmount, getImageUrl } from '../../utility/common';
import * as cartActions from '../../data/reducers/cart.reducer';
import { PrimaryButton } from '../../shared/components/common/primary_button';
import CouponInput from '../cart/coupon_input';

export const OrderReviewPage = () => {
  const { storeSlug } = useParams<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [couponCode, setCouponCode] = useState('');
  
  const { cartItems, cartItemCount, cartSubTotalAmount, discount, cartTotalAmount, setCoupon, calculateTotal } =
    useCart();
  const { shopperAccountId, phoneNumber } = useSelector((state: RootState) => state.authReducer);
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { addressInfo, orderPlaced, placedOrderInfo, isLoading, appliedCouponDiscountAmount } = useSelector((state: RootState) => state.cartReducer);
  
  useEffect(() => {
    calculateTotal();
  }, [cartItems]);

  const placeOrder = () => {
    console.log(addressInfo);
    dispatch(
      cartActions.placeOrder({
        shopperAccount: {
          shopperAccountId: shopperAccountId,
          phoneNumber: phoneNumber,
          fullName: addressInfo.fullName,
        },
        couponCode: couponCode,
        merchantStoreId: storeInfo?.merchantStoreId,
        fulfilmentType: addressInfo.OrderType,
      }),
    );
  };

  useEffect(() => {
    if (orderPlaced) {
      navigate(`/${storeSlug}/buy/orderplaced/${placedOrderInfo.purchaseOrderId}`);
    } else if (cartItemCount === 0) {
      navigate(`/${storeSlug}`);
    }
  }, [orderPlaced]);

  useEffect(() => {
    dispatch(cartActions.clearCoupon({}));
  }, []);

  return (
    <NavigationShell title={`Place order`} isBackVisible={true}>
      <div className="-mt-14">
        {storeInfo?.deliveryAvailable ? (
          <div className="text-theDarkOne text-left mx-6 py-6 border-b">
            <h3 className="uppercase font-medium mb-1">{addressInfo?.OrderType == 'DELIVERY' ? 'Shipping address' : 'Order details'}</h3>
            <div>
              {addressInfo?.fullName}
              <div className="text-theLighterDark mb-1">{addressInfo?.contactNumber ?? phoneNumber}</div>
              {addressInfo?.OrderType == 'DELIVERY' ? (
                <div className="font-medium">
                  {addressInfo?.Address1} {addressInfo?.Address2 ?? `,${addressInfo?.Address2},`}{' '}
                  {addressInfo?.Landmark ?? `,${addressInfo?.Landmark},`} {addressInfo?.Locality}
                  {', '}
                  {addressInfo?.City}
                  {', '}
                  {addressInfo?.Province}{' '}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}

        {/*Add Cart Product listing */}
        <div className="flex-row px-6 pb-4">
          {cartItems.map((product) => {
            return <CartProductTile key={product.storeProductId} product={product} isEditDisabled={true} />;
          })}
        </div>

        <div className="w-full border-t border-gray-300"></div>

        <div className="flex-row md:flex-row px-6 pb-4 divide-y">
          {/* Sub Total */}
          <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Sub Total
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(cartSubTotalAmount)}
            </div>
          </div>

          {/* Coupon */}
          {/* <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Coupon
            </div>
            <input
              type="number"
              className="w-1/2 md:w-1/2 flex flex-row-reverse md:flex md:flex-row-reverse form-control text-sm font-bold focus:outline-none text-right"
              placeholder="Enter"
              value={discount}
              onChange={(e: any) => setCoupon(e.target.value)}
            />
          </div> */}
          <div className="flex md:flex bg-white pb-4 md:pb-4 pt-4 md:pt-4">
              <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
                Coupon
              </div>
              <div className="w-full md:w-1/2 flex flex-row-reverse md:flex md:flex-row-reverse form-control text-sm text-right">
                <CouponInput setCouponCode={setCouponCode} couponCode={couponCode} />
              </div>
            </div>

            {/* Discount */}
          <div className="flex md:flex bg-white pt-4 md:pt-4 pb-4 md:pb-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Discount
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(appliedCouponDiscountAmount)}
            </div>
          </div>

          {/* Total */}
          <div className="flex md:flex bg-white pt-4 md:pt-4">
            <div className="w-1/2 md:w-1/2 text-left md:text-left space-y-1 font-inter font-medium text-black">
              Total
            </div>
            <div className="w-1/2 md:w-1/2 text-right md:text-right space-y-1 font-semibold text-black">
              {formatAmount(cartTotalAmount - appliedCouponDiscountAmount)}
            </div>
          </div>
        </div>

        <div className="w-full border-t border-gray-300 mb-28"></div>

        <div className="p-6 fixed w-full bottom-0 bg-white">
          <PrimaryButton text="Place order" isLoading={isLoading} onclick={placeOrder} />
        </div>
      </div>
    </NavigationShell>
  );
};
